import React from 'react';
import {
  House,
  CheckAll,
  PersonCheck,
  Link45deg,
  CloudArrowDown,
  Gear,
  Phone,
  CreditCard2Front,
  GraphUp,
  List,
  Laptop,
  CardChecklist
} from 'react-bootstrap-icons';
import Dashboard from './views/pages/Dashboard';
// import Login from './views/pages/Login';
import Visits from './views/pages/Visits';
import Sales from './views/pages/Sales';
import Icon from './views/pages/Icon';
import Material from './views/pages/Material';
import ClubInformation from './views/pages/ClubInformation';
import Contact from './views/pages/Contact';
import Order from './views/pages/Order';
import Statistic from './views/pages/Statistic';
import Map from './views/pages/Map';
import Visitors from './views/pages/Visitors';
import Invoices from './views/pages/Invoices';
import InvoicePdf from './views/pages/InvoicePdf';
import WebSales from './views/pages/WebSales';
import Notifications from './views/pages/Notifications';
import Comments from './views/pages/Comments';
import SeasonOpen from './views/pages/SeasonOpen';
import CardsReport from './views/pages/CardsReport';
import DigitalCardsCreate from './views/pages/DigitalCardsCreate';

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <House size={16} />,
    component: <Dashboard />,
    layout: '/golfclub-admin'
  },
  {
    path: '/visits',
    name: 'Besöksregistrering',
    icon: <PersonCheck size={18} />,
    component: <Visits />,
    layout: '/golfclub-admin'
  },
  {
    path: '/sales',
    name: 'Sälj Golfamore',
    icon: <CheckAll size={20} />,
    component: <Sales />,
    layout: '/golfclub-admin'
  },
  {
    path: '/order',
    name: 'Beställ Golfamore',
    icon: <CreditCard2Front size={16} />,
    component: <Order />,
    layout: '/golfclub-admin'
  },
  {
    path: '/web-sales',
    name: 'Webb-försäljning',
    icon: <Laptop size={16} />,
    component: <WebSales />,
    layout: '/golfclub-admin'
  },
  {
    collapse: true,
    name: 'Statistik',
    icon: <GraphUp size={14} />,
    state: 'dashboardsCollapse',
    path: 'statistic',
    views: [
      {
        path: '/statistic/overview',
        name: 'Översikt',
        miniName: '',
        component: <Statistic />,
        layout: '/golfclub-admin'
      },
      {
        path: '/statistic/map',
        name: 'Karta',
        miniName: '',
        component: <Map />,
        layout: '/golfclub-admin'
      },
      {
        path: '/statistic/visitors',
        name: 'Besökare',
        miniName: '',
        component: <Visitors />,
        layout: '/golfclub-admin'
      },
      {
        path: '/statistic/comments',
        name: 'Kommentarer',
        miniName: '',
        component: <Comments />,
        layout: '/golfclub-admin'
      }
    ]
  },
  {
    path: '/club-information',
    name: 'Klubb-information',
    icon: <Gear size={18} />,
    component: <ClubInformation />,
    layout: '/golfclub-admin'
  },
  {
    path: '/material',
    name: 'Material',
    icon: <CloudArrowDown />,
    component: <Material />,
    layout: '/golfclub-admin'
  },
  {
    path: '/invoices',
    name: 'Fakturor',
    icon: <List />,
    component: <Invoices />,
    layout: '/golfclub-admin'
  },
  {
    path: '/icon',
    name: 'Hämta genväg',
    icon: <Link45deg />,
    component: <Icon />,
    layout: '/golfclub-admin'
  },
  {
    path: '/contact',
    name: 'Kontakta oss',
    icon: <Phone size={16} />,
    component: <Contact />,
    layout: '/golfclub-admin'
  },
  {
    path: '/notifications',
    name: 'Notifikationer',
    component: <Notifications />,
    layout: '/golfclub-admin',
    noMenu: true
  },
  {
    path: '/invoice',
    name: 'Faktura',
    icon: <List />,
    component: <InvoicePdf />,
    layout: '/golfclub-admin',
    noMenu: true
  },
  {
    path: '/season-open',
    name: 'Säsongsöppning',
    icon: <List />,
    component: <SeasonOpen />,
    layout: '/golfclub-admin'
    // noMenu: true
  },
  {
    path: '/cards-report',
    name: 'Kortrapportering',
    icon: <CardChecklist />,
    component: <CardsReport />,
    layout: '/golfclub-admin',
    onlySuperAdmin: true
  },
  {
    path: '/digital-cards-create',
    name: 'Skapa digitala kort',
    icon: <CardChecklist />,
    component: <DigitalCardsCreate />,
    layout: '/golfclub-admin',
    onlySuperAdmin: true
  }
];

export default routes;
